<script>
import { imgHost2 } from "@/config/index";


export default {
  props: {
    planData: {
      type: Array | Object,
      default: () => []
    }
  },
  data () {
    return {
      imgHost2
    };
  }
}
</script>

<template>
  <div v-if="planData" class="care-program">
    <div class="care-program-step">
      <img :src="`${imgHost2}/ywa_pic.png`" mode="aspectFit" class="care-program-step-pic" />
    </div>

    <div class="care-program-content">
      <div class="care-program-content-text">
        {{ planData[0].symptom }}
      </div>
    </div>

    <div class="care-program-step">
      <img :src="`${imgHost2}/yq_pic.png`" mode="aspectFit" class="care-program-step-pic" />
    </div>

    <div class="care-program-content">
      <div class="care-program-content-text">
        {{ planData[1].symptom }}
      </div>
    </div>

    <div class="care-program-step">
      <img :src="`${imgHost2}/eq_pic.png`" mode="aspectFit" class="care-program-step-pic" />
    </div>

    <div class="care-program-content">
      <div class="care-program-content-text">
        {{ planData[2].symptom }}
      </div>
    </div>

    <div class="care-program-step">
      <img :src="`${imgHost2}/sq_pic.png`" mode="aspectFit" class="care-program-step-pic" />
    </div>

    <div class="care-program-content">
      <div class="care-program-content-text">
        {{ planData[3].symptom }}
      </div>
    </div>

    <div class="care-program-step">
      <img :src="`${imgHost2}/siq_pic.png`" mode="aspectFit" class="care-program-step-pic" />
    </div>

    <div class="care-program-content">
      <div class="care-program-content-text">
        {{ planData[4].symptom }}
      </div>
    </div>
  </div>
  <div v-else>
    暂无癌症相关数据
  </div>
</template>

<style lang="scss" scoped>
$borderRadius: 8px;

$activeBorderColor: #6580f8;

.care-program {
  position: relative;
  width: 100%;
  display: grid;
  grid-template-columns: auto 1fr;
  grid-template-rows: repeat(5, 70px);

  >div {
    position: relative;
    width: 100%;
    height: 100%;
    text-align: center;
    font-size: 16px;
    font-weight: bold;
  }

  &-step {
    &-pic {
      position: relative;
      height: 100%;
      width: 80rpx;
    }
  }

  &-content {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px;

    &-text {
      position: relative;
      width: 100%;
      height: 100%;
      background-color: #edf0ff;
      border-radius: $borderRadius;
      display: flex;
      align-items: center;
      justify-content: center;

      font-weight: 600;
      color: #282a2c;
      text-align: left;
      font-style: normal;
      text-transform: none;
    }
  }
}

.btlr {
  border-top-left-radius: $borderRadius;
}

.btrr {
  border-top-right-radius: $borderRadius;
}

.bblr {
  border-bottom-left-radius: $borderRadius;
}

.bbrr {
  border-bottom-right-radius: $borderRadius;
}
</style>
